var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchCategoryApplicationIntegration32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture-Category/32/Application-Integration_32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0084D",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4F8B",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture-Category/32/Application-Integration_32",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-1)",
    x: 4,
    y: 4,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    id: "#879196-Border-Copy",
    stroke: "#879196",
    strokeWidth: 2,
    x: 1,
    y: 1,
    width: 46,
    height: 46
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon-Category/32/Application-Integration_32",
    transform: "translate(8.000000, 8.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29,15 L24.692,15 C24.898,14.585 25.007,14.127 25.007,13.651 C25.007,12.598 24.476,11.632 23.586,11.066 C22.673,10.487 21.557,10.434 20.517,10.921 C19.963,11.181 19.511,11.623 19.244,12.166 C18.779,13.112 18.779,14.143 19.202,15 L15,15 L15,9.808 C15,9.604 14.876,9.42 14.686,9.344 C14.498,9.268 14.278,9.315 14.139,9.463 C13.626,9.998 12.694,10.382 11.606,9.849 C11.271,9.684 10.987,9.393 10.825,9.05 C10.487,8.329 10.518,7.561 10.91,6.942 C11.594,5.866 13.25,5.693 14.138,6.626 C14.279,6.774 14.498,6.82 14.686,6.746 C14.876,6.669 15,6.486 15,6.281 L15,3 L27.5,3 C28.327,3 29,3.673 29,4.5 L29,15 Z M29,27.5 C29,28.327 28.327,29 27.5,29 L15,29 L15,23.967 C15.856,24.391 16.887,24.39 17.835,23.925 C18.378,23.658 18.819,23.207 19.079,22.653 C19.566,21.616 19.514,20.498 18.934,19.585 C18.368,18.694 17.402,18.163 16.349,18.163 C15.872,18.163 15.414,18.271 15,18.477 L15,16 L20.184,16 C20.388,16 20.572,15.875 20.647,15.686 C20.724,15.496 20.677,15.279 20.528,15.138 C19.992,14.626 19.608,13.692 20.143,12.606 C20.307,12.272 20.598,11.988 20.942,11.826 C21.662,11.487 22.43,11.517 23.05,11.911 C23.648,12.292 24.007,12.942 24.007,13.651 C24.007,14.215 23.778,14.743 23.364,15.138 C23.217,15.279 23.17,15.497 23.246,15.686 C23.322,15.875 23.506,16 23.71,16 L29,16 L29,27.5 Z M3,27.5 L3,16 L6.023,16 C5.601,16.857 5.602,17.888 6.066,18.834 C6.332,19.376 6.783,19.819 7.338,20.079 C7.809,20.3 8.296,20.41 8.772,20.41 C9.348,20.41 9.908,20.25 10.407,19.934 C11.297,19.368 11.828,18.402 11.828,17.349 C11.828,16.873 11.72,16.415 11.514,16 L14,16 L14,19.46 C14,19.665 14.124,19.848 14.314,19.924 C14.501,20 14.72,19.953 14.862,19.805 C15.754,18.872 17.406,19.043 18.09,20.121 C18.482,20.739 18.513,21.507 18.175,22.228 C18.013,22.571 17.729,22.863 17.394,23.027 C16.305,23.561 15.373,23.178 14.862,22.641 C14.72,22.493 14.501,22.447 14.314,22.522 C14.124,22.598 14,22.782 14,22.986 L14,29 L4.5,29 C3.673,29 3,28.327 3,27.5 L3,27.5 Z M3,4.5 C3,3.673 3.673,3 4.5,3 L14,3 L14,5.299 C13.586,5.093 13.128,4.985 12.651,4.985 C11.598,4.985 10.632,5.516 10.066,6.406 C9.486,7.319 9.434,8.438 9.921,9.475 C10.181,10.028 10.622,10.479 11.165,10.746 C12.112,11.211 13.144,11.212 14,10.789 L14,15 L10.531,15 C10.327,15 10.144,15.125 10.067,15.314 C9.991,15.503 10.038,15.721 10.186,15.862 C10.6,16.257 10.828,16.785 10.828,17.349 C10.828,18.058 10.47,18.708 9.871,19.089 C9.251,19.482 8.484,19.512 7.764,19.174 C7.419,19.012 7.128,18.728 6.964,18.394 C6.431,17.308 6.813,16.374 7.35,15.862 C7.498,15.721 7.545,15.504 7.469,15.314 C7.394,15.125 7.209,15 7.005,15 L3,15 L3,4.5 Z M27.5,2 L4.5,2 C3.121,2 2,3.122 2,4.5 L2,27.5 C2,28.878 3.121,30 4.5,30 L27.5,30 C28.879,30 30,28.878 30,27.5 L30,4.5 C30,3.122 28.879,2 27.5,2 L27.5,2 Z",
    id: "Application-Integration_Category-Icon_32_Squid--"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchCategoryApplicationIntegration32);
export default __webpack_public_path__ + "static/media/Arch-Category_Application-Integration_32.9db97277fac89e622e74c034206608a7.svg";
export { ForwardRef as ReactComponent };